import { render, staticRenderFns } from "./VideoCallDSTB.vue?vue&type=template&id=1795ee3e&scoped=true&"
import script from "./VideoCallDSTB.vue?vue&type=script&lang=js&"
export * from "./VideoCallDSTB.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallDSTB.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoCallDSTB.vue?vue&type=style&index=1&id=1795ee3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795ee3e",
  null
  
)

export default component.exports